import Vue from 'vue';

const findComponent = (here: Vue, name: string) => {
  for (; here !== here.$root; here = here.$parent) {
    if (here.$options.name === name) {
      return here;
    }
  }
  return null;
};

export default Vue.extend({
  data() {
    return {
      $form: undefined as any,
    };
  },
  computed: {
    freeze(): boolean {
      if (this.$form === null) { return false; }
      if (this.$form === undefined) { this.$form = findComponent(this, 'Form'); }
      if (this.$form) { return this.$form.freeze; }
      return false;
    },
  },
});
